import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  flexHalf: {
    flex: 0.5,
  },
}));
